module.exports = __webpack_public_path__ + "img/mySql.bab2c760.png";